// Write your code here
import './index.css'

import {Component} from 'react'

class TodoItem extends Component {
  delete = () => {
    const {item, onDelete} = this.props
    onDelete(item.id)
  }

  render() {
    const {item} = this.props
    const {title} = item

    return (
      <li className="item-container">
        <p className="todo-title">{title}</p>
        <button onClick={this.delete} type="button" className="button">
          Delete
        </button>
      </li>
    )
  }
}

export default TodoItem
